import { render, staticRenderFns } from "./BemAbaBasico.vue?vue&type=template&id=73ce0a14&"
import script from "./BemAbaBasico.vue?vue&type=script&lang=js&"
export * from "./BemAbaBasico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports